var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVolumeOn15X({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "21px",
    viewBox: "0 0 25 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "10C59EEB-20C8-46D9-864C-05B74DA7B0A9@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Schools/Web-Player",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schools/Lessons/Player",
    transform: "translate(-752.000000, -703.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(753.000000, 704.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4438462,0.322332323 C13.4784914,-0.356320044 14.7890315,0.0715794127 15.3710194,1.27807251 C15.5519927,1.65324009 15.6470588,2.07643375 15.6470588,2.50688132 L15.6470588,16.4935632 C15.6470588,17.87783 14.6847261,19 13.4976285,19 C13.1284922,19 12.7655765,18.889144 12.4438462,18.6781122 L5.54308568,13.9651536 L2.21723427,13.9651536 C0.992689597,13.9651536 0,13.0755756 0,11.9782255 L0,7.01090528 C0,5.91355519 0.992689597,5.02397718 2.21723427,5.02397718 L5.54308568,5.02397718 L12.4438462,0.322332323 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5882353,4.24162424 C19.0329005,4.24162424 14.5294118,8.74511293 14.5294118,14.3004478",
    id: "Path",
    transform: "translate(19.558824, 9.271036) rotate(-225.000000) translate(-19.558824, -9.271036) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1573614,7.03574188 C17.6883237,7.03574188 15.6867732,9.03729241 15.6867732,11.5063301",
    id: "Path",
    transform: "translate(17.922067, 9.271036) rotate(-225.000000) translate(-17.922067, -9.271036) "
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOn15X);
export default __webpack_public_path__ + "static/media/VolumeOn@1.5x.ca7404cc4feae62fd98d40d9b04955e3.svg";
export { ForwardRef as ReactComponent };